import React, { Component } from "react";
import { Navigate, redirect } from "react-router-dom";
import { ApplicationEnum, UserRole } from "../Pages/ApiCommonService";
import PageNotFound from "../Pages/PageNotFound";

interface DefaultRouteProps {
  roleId?: number;
  selectedAppId?: number;
}

class DefaultRoute extends Component<DefaultRouteProps> {
  render() {
    const { roleId, selectedAppId } = this.props;

    let redirectPath = "";

    if (selectedAppId === ApplicationEnum.UserManagement) {
      redirectPath = "usermaster";
    } else {
      switch (roleId) {
        case UserRole.CSR:
        case UserRole.BrokerAdmin:
          redirectPath = "home/csrdashboard";
          break;

        case UserRole.ExdionAdmin:
          redirectPath = "introducebroker";
          break;

        case UserRole.MSUser:
          redirectPath = "InterUpload";
          break;

        case UserRole.Reviewer:
        case UserRole.QA:
          redirectPath = "home/dashboard";
          break;

        case UserRole.Supervisor:
          redirectPath = "jobs/joblisting";
          break;
      }
    }

    return redirectPath ? (
      <Navigate to={redirectPath} replace />
    ) : null;
  }
}


export default DefaultRoute;
